import { Typography } from '@material-ui/core'
import React from 'react'

import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import { makeStyles } from '@material-ui/core'
const useStyles = makeStyles((theme) => ({
  select: {
    backgroundColor: 'none',
  },
}))
// import { colourOptions } from '../data'

const animatedComponents = makeAnimated()

export default function MultipleSelectInput({ value, options, form, setForm, name, label, handleChange }) {
  const customStyles = {
    control: () => ({
      backgroundColor: 'none',
      alignItems: 'center',
      minHeight: '38px',
      position: 'relative',
      outline: '0!important',
      transition: 'all 100ms',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      cursor: 'pointer',
      border: 'none',
      display: 'flex',
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1
      const transition = 'opacity 300ms'

      return { ...provided, opacity, transition }
    },
  }
  //console.log("multiselect ", value)
  const handleFormChange = (e) => {
    setForm({ ...form, mustItem: Array.isArray(e) ? e.map((x) => ({ _id: x.value, name: x.label })) : [] })
  }
  const handleChangeNew = (e) => {
    handleChange(Array.isArray(e) ? e.map((x) => ({ _id: x.value, name: x.label })) : [])
  }
  let tempOptions =
    name === 'targetFor' || name === 'store'
      ? options &&
        options.map((item) => {
          return { label: item.name, value: item._id }
        })
      : options &&
        options.map((item) => {
          return { label: `${item.name} / ${item.sku}`, value: item._id }
        })

  return (
    <>
      <Typography style={{ fontWeight: 600, fontSize: '14px', marginTop: '15px' }}>{label}</Typography>
      <Select
        closeMenuOnSelect={false}
        components={animatedComponents}
        value={value}
        isMulti
        options={tempOptions}
        // value={value}
        onChange={handleChange ? handleChangeNew : handleFormChange}
        styles={customStyles}
        // style={{ marginTop: '30px' }}
        placeholder={''}
        name={name}
      />
    </>
  )
}
